module.exports = __webpack_public_path__ + "static/media/1-th.91ecae5.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/1-th.wav
// module id = RxCi
// module chunks = 1